module.exports = __webpack_public_path__ + "static/media/2. Add to Confluence.3f4d850f.svg";